import { api } from "@/lib/api-client";

const blobToDataURI = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (typeof reader.result === "string") {
        resolve(reader.result);
      } else {
        reject(new Error("Failed to convert blob to data URI"));
      }
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const getImageContent = async (imageUrl: string) => {
  const response: Blob = await api.get(`${imageUrl}`, {
    responseType: "blob",
  });

  const dataURI = await blobToDataURI(response);

  return dataURI;
};
